export default {
  sortStrings(firstString: string, secondString: string) {
    return new Intl.Collator().compare(firstString, secondString);
  }
};
